import { Html, html } from 'rune-ts';
import { Input_Base } from './Input_Base.ts';
import klass from './Input.module.scss';
import base_klass from '../../../../../shared/component/atom/Input/core/input.module.scss';
import { shareFont } from '@services/MarppleShop/shared/typography';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import {
  pureInputKlass,
  pureInputVariant,
} from '../../../../../../../shared/rune-component/Input/PureInput.ts';
import { controlErrorMessage } from '@services/MarppleShopStudio/shared/component/atom/Input/core/helper.ts';
import { ValidateField } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import {
  NumberTextInput,
  NumberTextInputType,
} from '../../../../../../../shared/rune-component/Input/NumberTextInput.ts';
import { EditorInputFocusoutEvent } from '@services/MarppleShopStudio/shared/component/atom/Input/core/events.ts';

interface InputNumberData extends InputEditor {
  value: number | null;
  onFocusOut?: (view: NumberTextInputType) => void;
  readonly?: boolean;
  option?: {
    decimal?: number;
    max?: number;
    min?: number;
    placeholder?: string;
    right_html?: Html;
    index?: number;
    is_commify?: boolean;
  };
}

export class Input_NumberEditor extends Input_Base<InputNumberData> {
  private readonly originalOnFocusOut = this.data.onFocusOut;

  private inputView = new NumberTextInput({
    variant: pureInputVariant.studio_editor,
    name: this.data.name,
    value: this.data.value ?? null,
    placeholder: this.data.option?.placeholder,
    max: this.data.option?.max,
    min: this.data.option?.min,
    is_commify: this.data.option?.is_commify,
    readonly: this.data.readonly,
    decimal: this.data.option?.decimal,
    onFocusout: (view) => {
      if (this.originalOnFocusOut) this.originalOnFocusOut(view);

      this.dispatchEvent(EditorInputFocusoutEvent, {
        bubbles: true,
        detail: {
          name: view.getName(),
          index: this.getIndex(),
        },
      });
    },
  });

  protected inputTemplate() {
    return html`
      <div class="${base_klass.input_container}">
        <div class="${klass.input_wrap}">${this.inputView} ${this.data.option?.right_html ?? ''}</div>
        <span class="${base_klass.error_message} ${shareFont('12_medium')}"></span>
      </div>
    `;
  }

  public override setError(is_error: boolean, message?: string): void {
    if (is_error) {
      this.inputView.addKlass(pureInputKlass.error);
    } else {
      this.inputView.removeKlass(pureInputKlass.error);
    }

    controlErrorMessage(this.element(), message);
  }

  public setMax(max: number) {
    this.inputView.setMax(max);
    return this;
  }

  public setMin(min: number) {
    this.inputView.setMin(min);
    return this;
  }

  public setValue(value: number) {
    this.inputView.setValue(value);
    this.data.value = value;
    return this;
  }

  public getName(): ValidateField {
    return this.data.name;
  }

  public getValue(): string {
    return this.inputView.getValue();
  }

  public getNumericValue(): number | null {
    return this.inputView.getNumericValue();
  }

  public getIndex(): number {
    return this.data.option?.index ?? 0;
  }
}
